export default {
    USER_DATA_MUTATION(state, payload){
        state.userData = payload
    },
    USER_JOB_DETAILS(state, payload) {
        state.userJobDetails = payload
    }
}
